import { endOfDay, endOfMonth, endOfWeek, startOfDay, startOfMonth, startOfWeek, startOfYear, subDays, subMonths, subWeeks } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { getDateFilterTimeZone } from '@/helpers';

/** Book Balance / WL Balance — preset period drives concrete `betDate` sent to API (same for list and export). */
export interface FiltersWithDatePeriodPreset {
    datePeriod: { value: string | null };
    betDate: { value: [Date, Date] | null };
}

function localCalendarDateInTimeZone(refDate: Date, timeZone: string): Date {
    const [year, month, day] = formatInTimeZone(refDate, timeZone, 'yyyy-MM-dd').split('-').map(Number);
    return new Date(year, month - 1, day, 12);
}

export function applyDatePeriodPresetToBetDate(filtersCopy: FiltersWithDatePeriodPreset): void {
    const datePeriod = filtersCopy.datePeriod.value;

    // UI-only preset: the API receives only the resulting betDateFrom/betDateTo.
    filtersCopy.datePeriod.value = null;

    if (!datePeriod || datePeriod === 'range') return;

    const timeZone = getDateFilterTimeZone();
    const today = localCalendarDateInTimeZone(new Date(), timeZone);

    switch (datePeriod) {
        case 'today':
            filtersCopy.betDate.value = [startOfDay(today), endOfDay(today)];
            break;
        case 'yesterday': {
            const yesterday = subDays(today, 1);
            filtersCopy.betDate.value = [startOfDay(yesterday), endOfDay(yesterday)];
            break;
        }
        case 'currentWeek':
            filtersCopy.betDate.value = [startOfWeek(today, { weekStartsOn: 1 }), endOfDay(today)];
            break;
        case 'lastWeek': {
            const lastWeekRef = subWeeks(today, 1);
            const lastWeekStart = startOfWeek(lastWeekRef, { weekStartsOn: 1 });
            const lastWeekEnd = endOfWeek(lastWeekRef, { weekStartsOn: 1 });
            filtersCopy.betDate.value = [startOfDay(lastWeekStart), endOfDay(lastWeekEnd)];
            break;
        }
        case 'currentMonth':
            filtersCopy.betDate.value = [startOfMonth(today), endOfDay(today)];
            break;
        case 'lastMonth': {
            const lastMonthRef = subMonths(today, 1);
            const lastMonthStart = startOfMonth(lastMonthRef);
            const lastMonthEnd = endOfMonth(lastMonthRef);
            filtersCopy.betDate.value = [startOfDay(lastMonthStart), endOfDay(lastMonthEnd)];
            break;
        }
        case 'currentYear':
            filtersCopy.betDate.value = [startOfYear(today), endOfDay(today)];
            break;
    }
}
